import React, { FC } from 'react'
import { Redirect, Switch, Route } from 'react-router-dom'
import { Rules } from './Rules'
import { routes } from '../../../constants/routes'

export const SettingsRulesRoutes: FC = () => {
  return (
    <Switch>
      <Route path={routes.SETTINGS_RULES_TABS} component={Rules} />
      <Redirect to={routes.SETTINGS_RULES} />
    </Switch>
  )
}
